import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation, getLocalizedField } from '../lib/i18n';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('pont10_language') || null;
  });

  useEffect(() => {
    if (language) {
      localStorage.setItem('pont10_language', language);
    }
  }, [language]);

  const t = (key) => getTranslation(language || 'es', key);
  const localize = (obj) => getLocalizedField(obj, language || 'es');

  const clearLanguage = () => {
    localStorage.removeItem('pont10_language');
    setLanguage(null);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, localize, clearLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
